import React from "react";
import { ChevronDown } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";

const Row = ({ checked, onToggle, text, testid }) => (
    <label className="flex items-center gap-2.5 px-2 py-1.5 rounded-md text-sm text-slate-700 hover:bg-slate-50 cursor-pointer" data-testid={testid}>
        <Checkbox checked={checked} onCheckedChange={onToggle} className="border-slate-300 data-[state=checked]:bg-[#2EB4AC] data-[state=checked]:border-[#2EB4AC] data-[state=checked]:text-white" />
        {text}
    </label>
);

export const MonthMultiSelect = ({ value, onChange, months, format, testid = "attendance-month-filter", optionPrefix = "month-option" }) => {
    const toggle = (m) => onChange(value.includes(m) ? value.filter((x) => x !== m) : [...value, m]);
    const label = value.length === 0 ? "All months" : value.length === 1 ? format(value[0]) : `${value.length} months`;
    return (
        <Popover>
            <PopoverTrigger asChild>
                <button
                    data-testid={testid}
                    className="relative h-10 pl-3 pr-8 rounded-lg border border-slate-200 bg-white text-sm text-slate-700 hover:border-slate-300 focus:outline-none focus:border-[#2EB4AC] focus:ring-2 focus:ring-teal-100 transition-colors"
                >
                    {label}
                    <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" />
                </button>
            </PopoverTrigger>
            <PopoverContent align="start" className="w-56 p-1.5 max-h-80 overflow-y-auto" data-testid={`${testid}-menu`}>
                <Row checked={value.length === 0} onToggle={() => onChange([])} text="All months" testid={`${optionPrefix}-all`} />
                <div className="my-1 h-px bg-slate-100" />
                {months.map((m) => (
                    <Row key={m} checked={value.includes(m)} onToggle={() => toggle(m)} text={format(m)} testid={`${optionPrefix}-${m}`} />
                ))}
            </PopoverContent>
        </Popover>
    );
};
